import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const LPRegister = lazyRouteComponent(() => import('../pages/lp-register'))

export const lpRegisterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/lp-registrate',
  component: LPRegister,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
